module.exports = __webpack_public_path__ + "img/ludogorets.abcf2172.png";